export const studentIdPattern = /^\d{10}$/;
